import React, { useContext, useEffect, useState } from 'react'
import { useHistory, useLocation } from "react-router-dom";
import { VentasContext } from '../VentasMain';
import { useSelector } from 'react-redux';
import request from '../../../Helpers/API';
import Swal from 'sweetalert2';
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from '../../components/LoaderScreen';
import { OperacionExpress } from '../../AnalisisCredito/Procesos/OperacionExpress';
import { OperacionCoordinadorCredito } from '../../AnalisisCredito/Procesos/OperacionCoordinadorCredito';
import { CreditoMhusaScreen } from '../../AnalisisCredito/CreditoMhusa/CreditoMhusaScreen';
import { AnalisisCreditoPrestamoCliente } from '../../AnalisisCredito/AnalisisCreditoPrestamoCliente';
import { AnalisisCreditoCondicionadoTimeline } from '../../AnalisisCredito/AnalisisCreditoCondicionadoTimeline';
import { MhusaContado } from '../../AnalisisCredito/CreditoMhusa/MhusaContado';
import { OperacionComiteCredito } from '../../AnalisisCredito/Procesos/OperacionComiteCredito';
import { RevolventeCoordinadorCredito } from '../../AnalisisCredito/Procesos/Revolvente/RevolventeCoordinadorCredito';
import { RevolventeComiteCredito } from '../../AnalisisCredito/Procesos/Revolvente/RevolventeComiteCredito';
import { CreditoJohnDeereFinancial } from '../../AnalisisCredito/Procesos/CreditoJohnDeereFinancial';
import { CreditoJDFCondicionado } from '../../AnalisisCredito/Procesos/CreditoJDFCondicionado';
import { AmpleacionCoordinador } from '../../AnalisisCredito/Procesos/Revolvente/AmpleacionCoordinador';
import { AmpleacionComite } from '../../AnalisisCredito/Procesos/Revolvente/AmpleacionComite';
import { Excedente } from '../../AnalisisCredito/Procesos/Revolvente/Excedente';
import { ReestructuracionSolicitudCredito } from '../../AnalisisCredito/Procesos/ReestructuracionSolicitudCredito';

// export const SolicitudesCerradasDetalleScreen = () => {
//     const { state, setState } = useContext(VentasContext);
//     console.log(state)
//     return (
//         <div>SolicitudesCerradasDetalleScreen</div>
//     )
// }

export const SolicitudesCerradasDetalleScreen = () => {
    const { state, setState } = useContext(VentasContext);
    const history = useHistory();
    // const location = useLocation();
    const [roperaciones, setRoperaciones] = useState({
        titulo: "",
        ejercicio: 0,
        periodo: 0,
        linea: "",
    });
    const [data, setData] = useState({
        estado: {},
        detalle: [],
    });
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

  




    useEffect(() => {
        onUpdateLineTime();
    }, []);
    // useEffect(() => {
    //     if (location.Roperaciones !== undefined && location.Roperaciones !== null) {
    //         setRoperaciones({
    //             titulo: location.Roperaciones.titulo,
    //             ejercicio: location.Roperaciones.ejercicio,
    //             periodo: location.Roperaciones.periodo,
    //             linea: location.Roperaciones.linea,
    //         });
    //     }
    // }, []);

    const onUpdateLineTime = () => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`ACTimeLine/ListadoCondicionado?folio=${state.folio}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setData({
                    estado: result.estado,
                    detalle: result.detalle,
                });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("ANALISIS DE CREDITO", JSON.stringify(error), "error");
            });
    };

    const onCreditoCondicionado = () => {
        setLoader({ ...loader, mostrar: true });
        const post = {
            folio: state.folio,
            usuario: "",
        };
        request
            .post(`SCCreditoCondicionado`, post)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setState((prevState) => ({
                    ...prevState,
                    folio: result.estado.folio,
                }));
                setData({
                    estado: result.estado,
                    detalle: result.detalle,
                });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("ANALISIS DE CREDITO", JSON.stringify(error), "error");
            });
    };

    const onModalComentarios = () => {
        // Mostrar confirmación antes de guardar
        Swal.fire({
            title: '¿Estás seguro de eliminarla?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
            customClass: {
                confirmButton: 'custom-confirm-button-cancel'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                onCancelarSolicitud("R");
            }
        });
    };


    const onCancelarSolicitud = (accion) => {
        setLoader({ ...loader, mostrar: true });

        const comentarios = "Solicitud cancelada por vendedor"

        const post = {
            folio: state.folio,
            accion: accion,
            comentarios: comentarios,
        };
        request
            .post(`PanelControlSolicitudes`, post)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
               
                history.push({
                    pathname: "/SolicitudCredito/Main", //"/SolicitudCredito/ResultadosOperacion
                    state: {
                        filtros: state.filtros,
                    },
                    Roperaciones: {
                        titulo: roperaciones.titulo,
                        ejercicio: roperaciones.ejercicio,
                        periodo: roperaciones.periodo,
                        linea: roperaciones.linea,
                    },
                })
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire(
                    "ANALISIS DE SOLICITUD DE CREDITO",
                    JSON.stringify(error),
                    "error"
                );
            });
    }

    const onCancelarCreditoCondicionado = () => {
        setLoader({ ...loader, mostrar: true });
        const post = {
            folio: state.folio,
            usuario: "",
        };
        request
            .post(`SCCreditoCondicionado/Cancelar`, post)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setState((prevState) => ({
                    ...prevState,
                    folio: result.estado.folio,
                }));
                setData({
                    estado: result.estado,
                    detalle: result.detalle,
                });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("ANALISIS DE CREDITO", JSON.stringify(error), "error");
            });
    };
    const ComponenProcess = () => {
        const modulo = data.estado.modulo;
        if (modulo === undefined || modulo === null) return <div></div>;
        switch (modulo) {
            case "OEX":
                return (
                    <OperacionExpress
                        data={data.detalle}
                        estado={data.estado}
                        upload={onUpdateLineTime}
                    ></OperacionExpress>
                );
            case "OCF":
                return (
                    <OperacionCoordinadorCredito
                        data={data.detalle}
                        estado={data.estado}
                        upload={onUpdateLineTime}
                    ></OperacionCoordinadorCredito>
                );
            case "CMH":
                return (
                    <CreditoMhusaScreen
                        data={data.detalle}
                        estado={data.estado}
                        upload={onUpdateLineTime}
                    ></CreditoMhusaScreen>
                );
            case "CPC":
                return (
                    <AnalisisCreditoPrestamoCliente
                        data={data.detalle}
                        estado={data.estado}
                        upload={onUpdateLineTime}
                    ></AnalisisCreditoPrestamoCliente>
                );
            case "CCC":
                return (
                    <AnalisisCreditoCondicionadoTimeline
                        data={data.detalle}
                        estado={data.estado}
                        upload={onUpdateLineTime}
                    ></AnalisisCreditoCondicionadoTimeline>
                );
            case "CON":
                return (
                    <MhusaContado
                        data={data.detalle}
                        estado={data.estado}
                        upload={onUpdateLineTime}
                    ></MhusaContado>
                );
            case "OCO":
                return (
                    <OperacionComiteCredito
                        data={data.detalle}
                        estado={data.estado}
                        upload={onUpdateLineTime}
                    ></OperacionComiteCredito>
                );
            case "RCF":
                return (
                    <RevolventeCoordinadorCredito
                        data={data.detalle}
                        estado={data.estado}
                        upload={onUpdateLineTime}
                    ></RevolventeCoordinadorCredito>
                );
            case "RCO":
                return (
                    <RevolventeComiteCredito
                        data={data.detalle}
                        estado={data.estado}
                        upload={onUpdateLineTime}
                    ></RevolventeComiteCredito>
                );
            case "JDF":
                return (
                    <CreditoJohnDeereFinancial
                        data={data.detalle}
                        estado={data.estado}
                        upload={onUpdateLineTime}
                    ></CreditoJohnDeereFinancial>
                );
            case "SCJ":
                return (
                    <CreditoJDFCondicionado
                        data={data.detalle}
                        estado={data.estado}
                        upload={onUpdateLineTime}
                    ></CreditoJDFCondicionado>
                );
            case "ACF":
                return (
                    <AmpleacionCoordinador
                        data={data.detalle}
                        estado={data.estado}
                        upload={onUpdateLineTime}
                    ></AmpleacionCoordinador>
                );
            case "ACO":
                return (
                    <AmpleacionComite
                        data={data.detalle}
                        estado={data.estado}
                        upload={onUpdateLineTime}
                    ></AmpleacionComite>
                );
            case "ECF":
                return (
                    <Excedente
                        data={data.detalle}
                        estado={data.estado}
                        upload={onUpdateLineTime}
                    ></Excedente>
                );
            case "RSC":
                return (
                    <ReestructuracionSolicitudCredito
                        data={data.detalle}
                        estado={data.estado}
                        upload={onUpdateLineTime}
                    ></ReestructuracionSolicitudCredito>
                );
            default:
                <></>;
        }
    };

    return (
        <div className="container-total-aaaaa">
            <div className="solicitud-credito-detalle-boton-container">
                <div
                    className="solicitud-credito-detalle-boton-regresar"
                    onClick={() =>
                        history.push({
                            pathname: "/SolicitudCredito/Main", //"/SolicitudCredito/ResultadosOperacion
                            state: {
                                folio: "",
                                cliente: "",
                                filtros: state.filtros,
                            },
                            Roperaciones: {
                                titulo: roperaciones.titulo,
                                ejercicio: roperaciones.ejercicio,
                                periodo: roperaciones.periodo,
                                linea: roperaciones.linea,
                            },
                        })
                    }
                >
                    <ArrowBackIcon /> Regresar
                </div>
            </div>
            {data.estado.creadorsolicitud === true && data.estado.modulo !== "RSC" && (
                <div className="solicitud-credito-detalle-boton-container-timeline-condicionado">
                    <div
                        className="solicitud-credito-detalle-boton-cancelar-timeline-condicionado"
                        onClick={() => onModalComentarios()}
                    >
                        <DeleteIcon /> Cancelar Solicitud
                    </div>
                </div>
            )}
            <LoaderScreen loader={loader} />
            <ComponenProcess />
        </div>
    );
};
